<template>
  <div class="casesDetailsPage">
    <head-top></head-top>
    <div class="casesHeadInfo" :style="{backgroundImage: 'linear-gradient(120deg, '+detailsInfo.shallowColor+' 0%, '+detailsInfo.deepColor+' 100%)'}">
      <div class="pageCenter">
        <div class="casesTop">
          <div class="casesImg">
            <img :src="detailsInfo.coverImg">
          </div>
          <div class="casesInfo">
            <div class="casesLogoName">
              <div class="casesLogo" v-if="detailsInfo.logo">
                <img :src="detailsInfo.logo" width="88px" height="88px">
              </div>
              <div class="name">
                <h3>{{detailsInfo.name}}</h3>
                <p>{{detailsInfo.industry}}</p>
              </div>
            </div>
            <div class="description">{{detailsInfo.description}}</div>
            <div class="but">
              <button v-for="(childItem,childIndex) of detailsInfo.preview" :key="childIndex">
                {{childItem.name}}
                <div class="code">
                  <span class="arrow"></span>
                  <div>
                    <img :src="childItem.img">
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div class="scanning">
          <div class="code" v-for="(childItem,childIndex) of detailsInfo.preview" :key="childIndex">
            <img :src="childItem.img">
            <span>{{childItem.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="interfaceShow">
      <div class="pageCenter">
        <div class="title">
          <span :style="{backgroundColor: detailsInfo.deepColor}"></span>
          界面展示
        </div>
        <div class="interfaceListBox" :style="{height:maxHeight+'px'}">
          <img v-for="(item,index) of detailsInfo.imgs" :src="item.url" :key="index" :style="{top:item.top+'px',left:item.left+'px'}">
        </div>
      </div>
    </div>
    <foot-guide></foot-guide>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      detailsInfo: {},
      maxHeight: 100
    };
  },
  methods: {
    imgSort() {
      var index = this.$route.params.index;
      var detailsInfo = casesDtata[index];
      var winWidth = window.innerWidth;
      if (winWidth <= 750) {
        this.detailsInfo = detailsInfo;
        return;
      }
      var calculationWidth = 1200;
      //位置
      var imgBit = [];
      var imgWidthRatio = 0.32;
      if (winWidth > 1200) {
        calculationWidth = 1200;
        imgBit = [
          {
            bit: 0,
            top: 0,
            left: 0
          },
          {
            bit: 1,
            top: 0,
            left: calculationWidth * 0.34
          },
          {
            bit: 2,
            top: 0,
            left: calculationWidth * 0.68
          }
        ];
      } else if (winWidth > 900) {
        calculationWidth = winWidth - winWidth * 0.03 * 2;
        imgBit = [
          {
            bit: 0,
            top: 0,
            left: 0
          },
          {
            bit: 1,
            top: 0,
            left: calculationWidth * 0.34
          },
          {
            bit: 2,
            top: 0,
            left: calculationWidth * 0.68
          }
        ];
      } else if (winWidth > 750) {
        calculationWidth = winWidth - winWidth * 0.03 * 2;
        imgBit = [
          {
            bit: 0,
            top: 0,
            left: 0
          },
          {
            bit: 1,
            top: 0,
            left: calculationWidth * 0.51
          }
        ];
        imgWidthRatio = 0.495;
      }
      function sortTop(a, b) {
        return a.top - b.top;
      }
      console.log(calculationWidth);
      var len = null;
      if (detailsInfo.imgs) {
        len = detailsInfo.imgs.length;
      } else {
        len = 0;
      }
      detailsInfo.imgs.forEach((item) => {
        var height =
          (item.height / item.width) * (calculationWidth * imgWidthRatio);
        var bitItem = imgBit.sort(sortTop)[0];
        item.top = bitItem.top;
        item.left = bitItem.left;
        imgBit[0].top = bitItem.top + height + 30;
      });
      this.detailsInfo = detailsInfo;
      if (len > 0) {
        this.maxHeight = imgBit.sort(sortTop)[imgBit.length - 1].top;
      }
    }
  },
  mounted() {
    const _this = this;
    this.imgSort();
    window.onresize = function () {
      _this.imgSort();
    };
  }
};
</script>
<style lang="scss" scoped>
@import "src/style/mixin";
@media screen and (min-width: 1200px) {
  .casesHeadInfo {
    .pageCenter {
      padding-top: 127px;
      max-width: 1200px;
      margin: 0 auto;
      .casesTop {
        display: flex;
        justify-content: space-between;
        .casesImg {
          display: flex;
          width: 670px;
          justify-content: center;
          align-items: flex-end;
          transform: translateX(-42px);
          img {
            width: 100%;
            display: block;
          }
        }
        .casesInfo {
          .casesLogoName {
            display: flex;
            .casesLogo {
              width: 88px;
              height: 88px;
              box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 20px;
              border-radius: 10px;
              img {
                display: block;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              h3 {
                font-size: 36px;
                color: #fff;
              }
              p {
                font-size: 24px;
                color: #fff;
              }
            }
          }
          .description {
            margin-top: 30px;
            width: 510px;
            line-height: 170%;
            font-size: 18px;
            color: #fff;
          }
          .but {
            display: flex;
            margin-top: 40px;
            button {
              width: 160px;
              height: 55px;
              border-radius: 6px;
              font-size: 24px;
              color: #ffffff;
              background-color: transparent;
              border: 2px solid #fff;
              border-radius: 6px;
              position: relative;
              &:nth-child(2),
              &:nth-child(3) {
                margin-left: 15px;
              }
              &:hover .code {
                display: flex;
              }
              > .code {
                position: absolute;
                top: 120%;
                background-color: #fff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
                padding: 10px 0 10px 10px;
                border-radius: 7px;
                display: none;
                .arrow,
                .arrow:before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-right: 7px solid transparent;
                  border-left: 7px solid transparent;
                }
                .arrow {
                  left: 73px;
                  top: -7px;
                  border-bottom: 7px solid #ddd;
                }
                .arrow:before {
                  left: 50%;
                  transform: translateX(-50%);
                  top: 1px;
                  border-bottom: 7px solid #fff;
                }
                > div {
                  width: 150px;
                  padding-right: 10px;
                  img {
                    width: 100%;
                    height: 140px;
                  }
                  p {
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
      }
      .scanning {
        display: none;
      }
    }
  }
  .interfaceShow {
    background-color: #fff;
    .pageCenter {
      padding: 62px 0px;
      .title {
        display: flex;
        align-items: center;
        font-size: 30px;
        color: #333333;
        span {
          display: block;
          width: 6px;
          height: 30px;
          border-radius: 3px;
          margin-right: 20px;
        }
      }
      .interfaceListBox {
        margin-top: 45px;
        position: relative;
        img {
          width: 32%;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          position: absolute;
        }
      }
    }
  }
}
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .casesHeadInfo {
    .pageCenter {
      padding-top: 10vw;
      .casesTop {
        display: flex;
        justify-content: space-between;
        .casesImg {
          display: flex;
          width: 50vw;
          justify-content: center;
          align-items: flex-end;
          img {
            width: 100%;
            display: block;
          }
        }
        .casesInfo {
          padding-right: 2vw;
          .casesLogoName {
            display: flex;
            .casesLogo {
              width: 7vw;
              height: 7vw;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 2vw;
              border-radius: 1vw;
              img {
                display: block;
                width: 100%;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              h3 {
                font-size: 3vw;
                color: #fff;
              }
              p {
                font-size: 2vw;
                color: #fff;
              }
            }
          }
          .description {
            margin-top: 2vw;
            width: 44vw;
            line-height: 170%;
            font-size: 1.6vw;
            color: #fff;
          }
          .but {
            display: flex;
            margin-top: 3vw;
            margin-bottom: 3vw;
            button {
              width: 13.5vw;
              height: 5vw;
              border-radius: 0.6vw;
              font-size: 2vw;
              color: #ffffff;
              background-color: transparent;
              border: 2px solid #fff;
              position: relative;
              &:nth-child(2),
              &:nth-child(3) {
                margin-left: 1.5vw;
              }
              &:hover .code {
                display: flex;
              }
              > .code {
                position: absolute;
                top: 120%;
                right: 0px;
                background-color: #fff;
                box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
                padding: 1vw 0 1vw 10px;
                border-radius: 7px;
                display: none;
                .arrow,
                .arrow:before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-right: 7px solid transparent;
                  border-left: 7px solid transparent;
                }
                .arrow {
                  left: 73px;
                  top: -7px;
                  border-bottom: 7px solid #ddd;
                }
                .arrow:before {
                  left: 50%;
                  transform: translateX(-50%);
                  top: 1px;
                  border-bottom: 7px solid #fff;
                }
                > div {
                  width: 150px;
                  padding-right: 10px;
                  img {
                    width: 100%;
                    height: 140px;
                  }
                  p {
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
      }
      .scanning {
        display: none;
      }
    }
  }
  .interfaceShow {
    background-color: #fff;
    .pageCenter {
      padding: 5vw 3vw;
      .title {
        display: flex;
        align-items: center;
        font-size: 30px;
        color: #333333;
        span {
          display: block;
          width: 6px;
          height: 30px;
          border-radius: 3px;
          margin-right: 20px;
        }
      }
      .interfaceListBox {
        margin-top: 4vw;
        position: relative;
        img {
          width: 32%;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          position: absolute;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 900px) {
  .casesHeadInfo {
    .pageCenter {
      padding-top: 10vw;
      .casesTop {
        display: flex;
        justify-content: space-between;
        .casesImg {
          display: flex;
          width: 50vw;
          justify-content: center;
          align-items: flex-end;
          display: none;
          img {
            width: 100%;
            display: block;
          }
        }
        .casesInfo {
          padding-right: 3vw;
          padding-left: 3vw;
          .casesLogoName {
            display: flex;
            .casesLogo {
              width: 7vw;
              height: 7vw;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 2vw;
              border-radius: 1vw;
              img {
                display: block;
                width: 100%;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              h3 {
                font-size: 3vw;
                color: #fff;
              }
              p {
                font-size: 2vw;
                color: #fff;
              }
            }
          }
          .description {
            margin-top: 2vw;
            line-height: 170%;
            font-size: 1.9vw;
            color: #fff;
          }
          .but {
            display: none;
          }
        }
      }
      .scanning {
        display: flex;
        justify-content: space-around;
        padding: 3vw;
        .code {
          width: 18vw;
          text-align: center;
          img {
            width: 100%;
          }
          span {
            color: #fff;
          }
        }
      }
    }
  }
  .interfaceShow {
    background-color: #fff;
    .pageCenter {
      padding: 6vw 3vw;
      .title {
        display: flex;
        align-items: center;
        font-size: 30px;
        color: #333333;
        span {
          display: block;
          width: 6px;
          height: 30px;
          border-radius: 3px;
          margin-right: 20px;
        }
      }
      .interfaceListBox {
        margin-top: 4vw;
        position: relative;
        img {
          width: 49.5%;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
          position: absolute;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .casesHeadInfo {
    .pageCenter {
      padding-top: 10vw;
      .casesTop {
        display: flex;
        justify-content: space-between;
        .casesImg {
          display: flex;
          width: 50vw;
          justify-content: center;
          align-items: flex-end;
          display: none;
          img {
            width: 100%;
            display: block;
          }
        }
        .casesInfo {
          padding-right: 4vw;
          padding-left: 4vw;
          .casesLogoName {
            display: flex;
            .casesLogo {
              width: 16vw;
              height: 16vw;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              flex-shrink: 0;
              margin-right: 2vw;
              border-radius: 1vw;
              img {
                display: block;
                width: 100%;
              }
            }
            .name {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              h3 {
                font-size: 5vw;
                color: #fff;
              }
              p {
                font-size: 4vw;
                color: #fff;
              }
            }
          }
          .description {
            margin-top: 6vw;
            line-height: 170%;
            font-size: 4vw;
            color: #fff;
          }
          .but {
            display: none;
          }
        }
      }
      .scanning {
        display: flex;
        justify-content: space-around;
        padding: 8vw 4vw 8vw 4vw;
        .code {
          width: 28vw;
          text-align: center;
          img {
            width: 100%;
          }
          span {
            color: #fff;
          }
        }
      }
    }
  }
  .interfaceShow {
    background-color: #fff;
    .pageCenter {
      padding: 6vw 3vw;
      .title {
        display: flex;
        align-items: center;
        font-size: 4vw;
        color: #333333;
        span {
          display: block;
          width: 6px;
          height: 30px;
          border-radius: 3px;
          margin-right: 20px;
        }
      }
      .interfaceListBox {
        margin-top: 4vw;
        height: initial !important;
        img {
          width: 100%;
          box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
          display: block;
          margin-bottom: 5vw;
        }
      }
    }
  }
}
</style>
